import PropTypes from "prop-types";
import { Card, Typography } from "@material-tailwind/react";
import { Link } from "react-router-dom";

export function TeamCard({ img, name, position, socials, id }) {
  return (
    <Card key={id} color="transparent" shadow={false} className="text-center group">
      <Link to={`/peopleID/${id}`} className="block mx-auto">
        <div className="relative w-40 h-40 mx-auto mb-4">
          <div className="absolute -inset-1 bg-gradient-to-br from-colorPrincipal to-colorSecudario rounded-full opacity-0 group-hover:opacity-70 blur transition-all duration-300"></div>
          <img
            src={img}
            alt={name}
            className="relative w-40 h-40 rounded-full object-cover shadow-xl ring-4 ring-gray-300 group-hover:scale-105 transition-transform duration-300"
          />
        </div>
      </Link>
      <Link to={`/peopleID/${id}`} className="block" style={{ textDecoration: "none" }}>
        <Typography variant="h6" color="blue-gray" className="mb-1 font-sans group-hover:text-colorPrincipal transition-colors duration-300">
          {name}
        </Typography>
      </Link>
      {position && (
        <Typography className="text-blue-gray-500 font-sans text-sm">
          {position}
        </Typography>
      )}
    </Card>
  );
}

TeamCard.defaultProps = {
  position: "",
  socials: null,
};

TeamCard.propTypes = {
  img: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  position: PropTypes.string,
  socials: PropTypes.node,
};

TeamCard.displayName = "/src/widgets/layout/team-card.jsx";

export default TeamCard;
